<form *transloco="let t; read: 'ime.manufacturing.manufacturing-graph-modal'">
  <div *ngIf="graph?.Nodes" class="chart-area min-vh-100">
    <ngx-graph id="graph-container-{{graph?.Id}}"
               class="chart-container"
               [links]="graph.Links" [curve]="curve" [layout]="layout" [enableZoom]="true" [autoCenter]="true" [autoZoom]="true" [panOnZoom]="true"
               [nodes]="graph.Nodes" [layoutSettings]="{orientation: 'LR'}"
               [update$]="update$">

      <ng-template #defsTemplate>
        <svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4" markerHeight="4" orient="auto">
          <svg:path d="M0,-5L10,0L0,5" class="arrow-head"/>
        </svg:marker>
      </ng-template>

      <ng-template #nodeTemplate let-node>
        <svg:g class="node" [ngbPopover]="nodeTooltipTemplate" #popover="ngbPopover" triggers="manual" [autoClose]="'outside'" (click)="togglePopover(popover, node)" container="body">
          <svg:rect [attr.width]="node.dimension.width" [attr.height]="node.dimension.height" [attr.rx]="4" [attr.ry]="4"
                    [attr.fill]="node | nodeColor: 'bg'" [attr.stroke]="node.StrokeColor" [attr.stroke-width]="node.StrokeWidth"/>
          <svg:text [attr.width]="node.dimension.width" [attr.height]="node.dimension.height" [attr.x]="10" [attr.y]="node.dimension.height / 2"
                    [attr.fill]="node | nodeColor: 'text'" alignment-baseline="central">
            {{node | nodeLabel}}
          </svg:text>
        </svg:g>
      </ng-template>

      <ng-template #linkTemplate let-link>
        <svg:g class="edge" [ngbPopover]="linkTooltipTemplate" #linkPopover="ngbPopover" triggers="manual" [autoClose]="'outside'" (click)="togglePopover(linkPopover, null, link)" container="body">
          <svg:path class="line" stroke-width="2" marker-end="url(#arrow)">
          </svg:path>
          <svg:text class="edge-label" text-anchor="middle">
            <textPath class="text-path" [attr.href]="'#' + link.id" [style.dominant-baseline]="link.dominantBaseline" startOffset="50%">
              {{link.label}}
            </textPath>
          </svg:text>
        </svg:g>
      </ng-template>

    </ngx-graph>
  </div>

  <ng-template #nodeTooltipTemplate let-node="node" let-close="close">
    <div class="m-n4">
      <div class="d-flex">
        <div ngbAccordion>
          <div ngbAccordionItem *ngIf="(node.isItemNode() && node.entityId === entityId) || node.type === EntityTypes.MasterOperation">
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton class="text-nowrap">{{t('Add Process')}}</button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <mes-web-process-select id="process-select" name="process-select" [items$]="processService.getAll$" [placeholder]="t('Process')" (entityIdChange)="addProcessFromSource(node.id, $event); close()"></mes-web-process-select>
                </ng-template>
              </div>
            </div>
          </div>
          <ng-container *ngIf="node.type === EntityTypes.MasterOperation">
            <div ngbAccordionItem>
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton class="text-nowrap">{{t('Add resource usage')}}</button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <mes-web-resource-select id="resource-usage-select" name="resource-usage-select" [items$]="resourcesQuery.getAll$" [placeholder]="t('Resource')" (entityIdChange)="addResourceUsage(node, $event); close()"></mes-web-resource-select>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem>
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton class="text-nowrap">{{t('Add item usage')}}</button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <mes-web-manufacturing-item-select id="item-usage-select" name="item-usage-select" [items$]="itemsQuery.getAll$" [placeholder]="t('Item')" (entityIdChange)="addItemUsage(node, $event); close()"></mes-web-manufacturing-item-select>
                  </ng-template>
                </div>
              </div>
            </div>
          </ng-container>
          <div ngbAccordionItem *ngIf="node.type === EntityTypes.MasterUseInstruction">
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton class="text-nowrap">{{t('Add resource')}}</button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <mes-web-resource-select id="resource-select" name="resource-select" [items$]="resourcesQuery.getAll$" [placeholder]="t('Resource')" (entityIdChange)="addResource(node, $event); close()"></mes-web-resource-select>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #linkTooltipTemplate let-link="link">
    <ul class="list-unstyled">
      <li>
        {{link.label}}
      </li>
    </ul>
  </ng-template>
</form>

